import MainLayout from "@/components/layout/MainLayout.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required, maxLength } from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters } from "vuex";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';
import xlsIcon from '@/assets/images/icon-xls.png';
import txtIcon from '@/assets/images/icon-txt.png';
import jpgIcon from '@/assets/images/icon-jpg.png';
import pngIcon from '@/assets/images/icon-png.png';
import videoIcon from '@/assets/images/video-icon.png';
import config from '@/assets/js/config.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const convertNumberService = new ConvertNumService();
export default {
    name: "createContentGroup",

    components: {
        MainLayout,
        AdvancedLaravelVuePaginate,
        Loading,
    },

    data() {
        return {
            contentRequestForm: {
                course_id: "",
                course_title: "",
                gp_name: "",
            },
            submitted: false,
            validation: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "bulletedList",
                    "numberedList"
                ]
            },
            tabs: [
                { name : 'createNew', label: 'အသစ် ထည့်ရန်'},
                { name : 'useExisting', label: 'ရှိပြီးသား ပြန်သုံးရန်'}
            ],
            currentTab: 'createNew',
            contentGroups: {
                data: [],
                current_page: 1,
                last_page: 1
            },
            lastPage: "",
            currentPage: "",
            currentPageMm: '',
            lastPageMm:'',
            courseId: this.$route.params.id,
            currentPagePagination: 1,
            expandedGroups: [],
            selectedGroups: {},
            selectedContents: {},
            group_id: 0,
            allSelected: false,
            selectAllPages: false,
            selectedGroupIds: [],
            selectedContentIds: [],
            config,
            allGroupIds: [],
            allContentGroups: [],
            isLoading: false,
            existingGroupIds: [],
            existingContentIds: [],
            unSelectedContentIds: [],
        };
    },

    validations: {
        contentRequestForm: {
            course_title: {
                required,
                maxLength: maxLength(100)
            },
            gp_name: {
                required,
                maxLength: maxLength(100)
            },
        }
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
      totalGroupsMm() {
        return convertNumberService.convertEng2Mm(this.contentGroups.total || 0);
      }
    },

    methods: {
        submit() {
            if (this.submitted) {
                return;
            }
            this.submitted = true;
            if (this.$v.contentRequestForm.$invalid) {
                this.submitted = false;
                this.validation = true;
                return;
            }
            this.createContent();
        },

        createContent() {
            var request = {
                group_name: this.contentRequestForm.gp_name,
            }
            axios.post("my/course/" + this.courseId + "/content-gp/create", JSON.stringify(request), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(() => {
                    this.$router.push({name: 'contentGroup', params: { id: this.courseId }})
                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });                        
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
        },

        getCourseName() {
            axios.get("my/course/" + this.courseId)
                .then((response) => {
                    this.contentRequestForm.course_title = response.data.course_title;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Name API error", error);
                });
        },

        goToContentGroup() {
            this.$router.push({ name: 'contentGroup', params: { id: this.courseId } });
        },

        async getContentGroupList(page = 1) {
            this.currentPagePagination = page;

            try {
                const [resGroups, resExistingGroups] = await Promise.all([
                    axios.get(`my/content-groups?page=${page}`),
                    axios.get(`my/course/${this.courseId}/content-gp/existing-content-gp`)
                ]);

                const groupsData = resGroups.data.data || {};
                const allGroups = groupsData.data || [];
                const currentPage = Number(groupsData.current_page) || 1;
                const lastPage = Number(groupsData.last_page) || 1;
                const existingGroupIds = (resExistingGroups.data || []).map(g => g.content_group_id);
                this.existingGroupIds = existingGroupIds;

                allGroups.forEach(group => {
                    group.expanded = false;
                    group.contents = [];
                    group.loading = false;
                    group.total_contents = convertNumberService.convertEng2Mm(group.contents_count);
                    const isExisting = existingGroupIds.includes(group.content_group_id);
                    group.selected = isExisting || !!this.selectedGroups[group.content_group_id];
                    group.disabled = isExisting;
                    this.$set(this.selectedGroups, group.content_group_id, group.selected);
                    if (group.selected && !this.selectedGroupIds.includes(group.content_group_id)) {
                        this.selectedGroupIds.push(group.content_group_id);
                    }
                    group.contents.forEach(c => {
                        c.selected = !!this.selectedContents[c.content_id];
                    });
                });

                this.contentGroups = {
                    data: allGroups || [],
                    current_page: currentPage,
                    last_page: lastPage,
                    total: Number(groupsData.total) || allGroups.length
                };

                this.currentPageMm = convertNumberService.convertEng2Mm(currentPage);
                this.lastPageMm = convertNumberService.convertEng2Mm(lastPage);
                this.currentPage = currentPage;
                this.lastPage = lastPage;

                this.updateAllSelected();
            } catch (error) {
                console.error("Error fetching content groups:", error);
            }
        },

        async getContentList(group) {
            const groupId = group.content_group_id;
            if (!groupId) return;

            this.$set(group, 'loading', true);
            try {
                const resContents = await axios.get(`/my/content-groups/${groupId}/contents/list`);
                const allContents = resContents.data.data || [];

                let existingContentsIds = [];
                if (this.existingGroupIds.includes(groupId)) {
                    const resExistingContents = await axios.get(`/my/course/${this.courseId}/content-gp/${groupId}/existing-contents`)
                        .catch(err => {
                            if (!err.response || err.response.status !== 403) {
                                console.error("Error fetching existing contents:", err);
                            }
                            return { data: { data: [] } };
                        });
                    existingContentsIds = (resExistingContents.data.data || []).map(Number);
                }

              this.existingContentIds.push(...existingContentsIds);
              this.existingContentIds = [...new Set(this.existingContentIds)];

                if (!group.contents) this.$set(group, 'contents', []);

                const newContents = allContents
                    .filter(c => !group.contents.some(gc => gc.content_id === c.content_id))
                    .map(c => {
                        const isExisting = existingContentsIds.includes(c.content_id);
                        const selected = (!group.manualToggle && (isExisting || !!this.selectedContents[c.content_id]));
                        return {
                            ...c,
                            selected,
                            disabled: isExisting,
                            fileIcon: this.getFileIcon(c.o_file_name)
                        };
                    });

                group.contents.push(...newContents);

                newContents.forEach(c => {
                    if (c.selected) {
                        this.$set(this.selectedContents, c.content_id, true);
                        if (!this.selectedContentIds.includes(c.content_id)) {
                            this.selectedContentIds.push(c.content_id);
                        }
                    }
                });
            } catch (error) {
                console.error("Error fetching contents:", error);
            }
        },

        getFileIcon(fileName = '') {
            const ext = fileName.split('.').pop()?.toLowerCase();
            if (!ext) return '';
            const icons = { pdf: pdfIcon, doc: docIcon, docx: docIcon, ppt: pptIcon, pptx: pptIcon,
                            xls: xlsIcon, xlsx: xlsIcon, txt: txtIcon, jpg: jpgIcon, jpeg: jpgIcon, png: pngIcon };
            if (['mp4','mov','avi','wmv','webm','flv','avchd'].includes(ext)) return videoIcon;
            return icons[ext] || '';
        },

        toggleGroup(group) {
            this.contentGroups.data.forEach(g => {
                if (g.content_group_id !== group.content_group_id) {
                    g.expanded = false;
                }
            });

            group.expanded = !group.expanded;

            if (group.expanded && !group.contents.length) {
                this.$set(group, 'loading', true);
                this.getContentList(group).finally(() => this.$set(group, 'loading', false));
            }
        },

        async toggleGroupSelection(group) {
            if (group.disabled) return;
            const selected = group.selected;
            const groupId = group.content_group_id;

            this.$set(group, 'manualToggle', true);
            if (!group.contents?.length) {
                this.$set(group, 'loading', true);
                await this.getContentList(group);
                this.$set(group, 'loading', false);
            }

            group.contents?.forEach(c => {
                c.selected = selected;
                if (selected) {
                    this.$set(this.selectedContents, c.content_id, true);
                    if (!this.selectedContentIds.includes(c.content_id)) {
                        this.selectedContentIds.push(c.content_id);
                    }
                } else {
                    this.$delete(this.selectedContents, c.content_id);
                    this.selectedContentIds = this.selectedContentIds.filter(id => id !== c.content_id);
                }
            });

            if (selected) {
                this.selectedGroups[groupId] = true;
                if (!this.selectedGroupIds.includes(groupId)) {
                    this.selectedGroupIds.push(groupId);
                }
            } else {
                this.$delete(this.selectedGroups, groupId);
                this.selectedGroupIds = this.selectedGroupIds.filter(id => id !== groupId);
                this.selectAllPages = false;
                this.allSelected = false;
            }
            this.updateAllSelected();
        },

        checkGroupSelection(group) {
            const groupId = group.content_group_id;

            if (!group.contents || group.contents.length === 0) {
                group.selected = !!this.selectedGroups[groupId];
                this.updateAllSelected();
                return;
            }

            group.selected = group.contents.some(c => c.selected);

            if (group.selected) {
                if (!this.selectedGroupIds.includes(groupId)) {
                    this.selectedGroupIds.push(groupId);
                }
            } else {
                this.selectedGroupIds = this.selectedGroupIds.filter(id => id !== groupId);
                this.selectAllPages = false;
            }

            group.contents.forEach(c => {
                if (c.selected) {
                    if (!this.selectedContentIds.includes(c.content_id)) {
                        this.selectedContentIds.push(c.content_id);
                    }
                } else {
                    this.selectedContentIds = this.selectedContentIds.filter(id => id !== c.content_id);
                }
            });

            this.selectedGroups[groupId] = group.selected;
            this.updateAllSelected();
        },

        toggleContentSelection(content, group) {
            if (content.disabled) return;
            content.selected = !content.selected;

            if (!this.selectedContents) this.selectedContents = {};

            if (content.selected) {
                this.selectedContents[content.content_id] = true;
                this.unSelectedContentIds = this.unSelectedContentIds.filter(c => c != content.content_id);
            } else {
                delete this.selectedContents[content.content_id];
                this.unSelectedContentIds.push(content.content_id);
            }

            this.checkGroupSelection(group);
        },

        async checkSelectAll() {
            if (!this.allContentGroups.length) return;
            const selectAll = this.selectAllPages;

            if (selectAll) {
                try {
                    this.allContentGroups.forEach(group => {
                        this.$set(this.selectedGroups, group.content_group_id, true);
                        if (!this.selectedGroupIds.includes(group.content_group_id)) {
                            this.selectedGroupIds.push(group.content_group_id);
                        }

                        group.contents?.forEach(c => {
                            this.$set(this.selectedContents, c.content_id, true);
                            if (!this.selectedContentIds.includes(c.content_id)) {
                                this.selectedContentIds.push(c.content_id);
                            }
                        });
                    });
                    this.contentGroups.data.forEach(group => {
                        group.selected = !!this.selectedGroups[group.content_group_id];
                        group.contents?.forEach(c => {
                            c.selected = !!this.selectedContents[c.content_id];
                        });
                    });

                } catch (error) {
                    console.error("Error fetching all groups for select all:", error);
                }
            } else {
                this.selectedGroupIds = this.selectedGroupIds.filter(id => {
                    const g = this.contentGroups.data.find(g => g.content_group_id === id);
                    if (g && g.disabled) return true;
                    this.$delete(this.selectedGroups, id);
                    return false;
                });

                this.selectedContentIds = this.selectedContentIds.filter(id => {
                    const c = this.contentGroups.data.flatMap(g => g.contents || []).find(x => x.content_id === id);
                    if (c && c.disabled) return true;
                    this.$delete(this.selectedContents, id);
                    return false;
                });

                this.contentGroups.data.forEach(group => {
                    if (!group.disabled) group.selected = false;
                    group.contents?.forEach(c => {
                        if (!c.disabled) c.selected = false;
                    });
                });
            }

            this.updateAllSelected();
        },

        async updateAllSelected() {
            if (!this.allGroupIds.length) return;

            const allGroupsSelected = this.allGroupIds.every(id => !!this.selectedGroups[id]);
            const unSelectedContents = this.unSelectedContentIds.length;
            this.allSelected = allGroupsSelected && !unSelectedContents;
            this.selectAllPages = allGroupsSelected && !unSelectedContents;
        },

        async addExistingGroups() {
            if (this.isLoading) return;
            this.isLoading = true;
            try {
                let allSelectedContentIds = [];

                if (this.selectAllPages) {
                    let response = await axios.get('my/content-groups/all-contents');
                    allSelectedContentIds = response.data.data || [];
                } else {
                    allSelectedContentIds = [
                        ...this.contentGroups.data.flatMap(group =>
                            group.contents?.filter(c => c.selected).map(c => c.content_id) || []
                        ),
                        ...Object.keys(this.selectedContents || {}).map(Number)
                    ];
                }
                allSelectedContentIds = [...new Set(allSelectedContentIds)];
                if (!allSelectedContentIds.length && !this.selectedGroupIds.length) {
                    this.$notification.error("ကျေးဇူးပြု၍ အနည်းဆုံး Content ၁ခု ရွေးပေးပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    return;
                }
                let currentGroupIds = this.contentGroups.data
                        .filter(g => g.selected)
                        .map(g => g.content_group_id);
                const payload = {
                    course_id: this.courseId,
                    content_ids: allSelectedContentIds || [],
                    group_ids: currentGroupIds,
                };
                const response = await axios.post(
                    `my/course/${this.courseId}/content-gp/add-existing`, payload);
                if (response.data.status === "success") {
                    this.$notification.success("Content များ ထည့်ပြီးပါပြီ။", {
                        timer: 2,
                        position: "bottomCenter"
                    });
                    this.goToContentGroup();
                } else {
                    console.log('condition entered');
                    this.$notification.error("Content ထည့်ရာတွင် ပြသာနာတစ်ခု ဖြစ်ပွားခဲ့သည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }
            } catch (error) {
                console.error("Error adding existing contents:", error);
                this.$notification.error("Server Error!", {
                    timer: 3,
                    position: "bottomCenter"
                });
            } finally {
                this.isLoading = false;
            }
        },

        async fetchAllGroupIds() {
            try {
                let response = await axios.get('my/content-groups/all');
                this.allGroupIds = response.data.data.map(g => g.content_group_id);
                this.allContentGroups = response.data.data;
            } catch (error) {
                console.error('Failed to fetch all group IDs:', error);
            }
        },
        
        confirmAddButton() {
          const newGroups = this.selectedGroupIds.filter(id => !this.existingGroupIds.includes(id));
          const newContents = this.selectedContentIds.filter(id => !this.existingContentIds.includes(id));
          const totalGroups = newGroups.length;
          const totalContents = newContents.length;

          if (!(totalGroups + totalContents)) {
            this.$modal.show("dialog", {
              title: "သတိပေးချက်",
              text: "ကျေးဇူးပြု၍ အနည်းဆုံး Content ၁ခု သို့မဟုတ် Group ၁ခု ရွေးပါ။",
              buttons: [{ title: "ဟုတ်ပြီ", handler: () => this.$modal.hide("dialog") }]
            });
            return;
          }

          const modalText = `<p>Content Group အရေအတွက်: ${totalGroups}</p>
                             <p>Content အရေအတွက်: ${totalContents}</p>`;

          this.$modal.show("dialog", {
            title: "Content Group အသစ် ထည့်ရန် သေချာပါသလား",
            text: modalText,
            buttons: [
              {
                title: "ထည့်မည်",
                handler: () => {
                  this.addExistingGroups();
                  this.$modal.hide("dialog");
                }
              },
              { title: "မထည့်ပါ", handler: () => this.$modal.hide("dialog") }
            ]
          });
        }
    },

    mounted() {
        this.getCourseName();
        this.getContentGroupList();
        this.fetchAllGroupIds();
    }
};
